import { IsEmail, IsEnum, IsNotEmpty, IsOptional, IsString, Length, MinLength } from 'class-validator';
import { UsuarioBackofficeTipo } from './usuario-backoffice-tipo.enum';

export class UsuarioBackofficeCriarDto {
  @IsString()
  @IsNotEmpty()
  nome: string;

  @IsEmail()
  @IsNotEmpty()
  email: string;

  @IsString()
  @IsOptional()
  @MinLength(6)
  password?: string;

  @IsString()
  @Length(10, 13)
  @IsOptional()
  telefone?: string;

  @IsString()
  @IsOptional()
  foto?: string;

  @IsEnum(UsuarioBackofficeTipo)
  @IsOptional()
  tipo?: UsuarioBackofficeTipo;
}
